import mobileAdjustment from '../GeneralMobileAdjustments'

class MobileTextInputControlView {

    constructor() {}

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        element.parent().css('position', 'relative');
        element.css('line-height', 'normal');
    }
}

const mobileTextInputControlView = new MobileTextInputControlView();
export default mobileTextInputControlView;